import * as React from 'react'
import t from './strings'
import {
  InlineChildren,
  Spacing,
  StackChildren,
  Text,
} from '@doordash/design-language'
import { connect } from 'react-redux'

type SignUpCompletionProps = { firstName: string }

const SignUpCompletion = ({ firstName }: SignUpCompletionProps) => (
  <div>
    <StackChildren size={Spacing.Large}>
      <InlineChildren justifyContent={InlineChildren.Justification.Center}>
        <img
          src="https://img.cdn4dd.com/s/managed/dasher/onboarding/thumb-up.svg"
          alt="Thumbs Up"
        />
      </InlineChildren>

      <Text styles={Text.Styles.MajorPageTitle}>{t.title(firstName)}</Text>

      <Text styles={Text.Styles.PageDescriptionBody}>{t.body()}</Text>
    </StackChildren>
  </div>
)

const mapStateToProps = state => ({
  firstName: state.application.firstName,
})

export default connect(mapStateToProps)(SignUpCompletion)
